import React from "react"
import "./card.css";

export const SelectCard = ({ text, image, button, selected = false, onClick = () => { } }) => {

    return <>
        <div className={`d-flex select-card ${selected ? "selected" : ""}`}>
            <div className="p-relative d-inline-block p-1 w-50">
                <div className="overflowed-image">
                    <img src={image} />
                </div>
            </div>
            <div className="p-1 content w-50">
                <h3>{text}</h3>
                <button onClick={onClick}>{button}</button>
            </div>
        </div>
    </>
}